import React, { useMemo } from 'react';
import Select from 'react-select';
import { selectStyles, SCHEDULED_MESSAGE_STATUS, MESSAGE_CREATED_BY_OPTIONS, MESSAGE_AUDIENCE_OPTIONS } from '../../utils';
import DateRangePicker from '../common/DateRangePicker/DateRangePicker';
import { MdSearch, MdRefresh } from "react-icons/md";

const STATUS_SELECT_OPTIONS = SCHEDULED_MESSAGE_STATUS.map((x) => ({
    value: x.value,
    label: x.label,
}));

const CREATED_BY_SELECT_OPTIONS = MESSAGE_CREATED_BY_OPTIONS.map((x) => ({
    value: x.value,
    label: x.label,
}));

export default function ScheduledMessagesFiltersBar({ draftFilters, setDraftFilters, onSearch, onReset }) {

    const statusValue = useMemo(() => {
        const v = draftFilters.status;
        if (v === '' || v === null || v === undefined) return null;
        return STATUS_SELECT_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.status]);

    const createdByValue = useMemo(() => {
        const v = draftFilters.createdBy;
        if (v === '' || v === null || v === undefined) return null;
        return CREATED_BY_SELECT_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.createdBy]);

    const audienceValue = useMemo(() => {
        const v = draftFilters.audience_type;
        if (v === '' || v === null || v === undefined) return null;
        return MESSAGE_AUDIENCE_OPTIONS.find((o) => Number(o.value) === Number(v))
            || { value: v, label: String(v) };
    }, [draftFilters.audience_type]);

    return (
        <div className="list-page-filter-bar">
            <div className="list-page-filter-fields row g-3 align-items-end">
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Notification ID"
                        value={draftFilters.notificationId || ''}
                        onChange={(e) =>
                            setDraftFilters((d) => ({ ...d, notificationId: e.target.value }))
                        }
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="scheduled-messages-status"
                            instanceId="scheduled-messages-status"
                            classNamePrefix="ns-sched-status"
                            isSearchable
                            isClearable
                            placeholder="Status"
                            aria-label="Status"
                            options={STATUS_SELECT_OPTIONS}
                            value={statusValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, status: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="scheduled-messages-created-by"
                            instanceId="scheduled-messages-created-by"
                            classNamePrefix="ns-sched-created-by"
                            isSearchable
                            isClearable
                            placeholder="Source"
                            aria-label="Source"
                            options={CREATED_BY_SELECT_OPTIONS}
                            value={createdByValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, createdBy: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div style={{ minWidth: 0, width: '100%' }}>
                        <Select
                            inputId="scheduled-messages-audience"
                            instanceId="scheduled-messages-audience"
                            classNamePrefix="ns-sched-audience"
                            isSearchable
                            isClearable
                            placeholder="Audience"
                            aria-label="Audience"
                            options={MESSAGE_AUDIENCE_OPTIONS}
                            value={audienceValue}
                            onChange={(opt) =>
                                setDraftFilters((d) => ({ ...d, audience_type: opt?.value ?? '' }))
                            }
                            styles={selectStyles}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <DateRangePicker
                        dateFrom={draftFilters.dateFrom || ''}
                        dateTo={draftFilters.dateTo || ''}
                        preset={draftFilters.datePreset || ''}
                        onChange={({ dateFrom, dateTo, preset }) =>
                            setDraftFilters((d) => ({
                                ...d,
                                dateFrom: dateFrom || '',
                                dateTo: dateTo || '',
                                datePreset: preset || '',
                            }))
                        }
                        label=""
                        placeholder="Send date"
                        allowClear
                    />
                </div>
                <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
                    <div className="add_app">
                        <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
                            <MdSearch />
                            <span>Search</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
                            <MdRefresh />
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
